import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAds } from '../contexts/AdContext';

/**
 * Custom hook for fetching user data
 * Eliminates duplicated user data fetching across 8+ components
 * Issue #268: Also initializes AdContext with user's ad consent preferences
 *
 * @returns {Object} - { userData, loading, error, refetch }
 */
const useUserData = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { initFromUserData } = useAds();

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/user/me');
      setUserData(response.data);
      // Issue #268: Initialize AdContext with user's ad consent preferences
      initFromUserData(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch user data:', err);
      if (err.response?.status === 401) {
        setError('Sitzung abgelaufen. Bitte erneut anmelden.');
      } else {
        setError('Fehler beim Laden der Benutzerdaten');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return {
    userData,
    loading,
    error,
    refetch: fetchUserData
  };
};

export default useUserData;
